<ng-content select="*:not(ui-tooltip-label)"></ng-content>
<div
  #tooltipElement
  class="tooltip"
  role="tooltip"
  [id]="uuid"
  [attr.aria-hidden]="!open"
  [class.open]="open"
  [class.close]="!open"
  [class.blue]="color === 'blue'"
  [class.yellow]="color === 'yellow'"
  [class.black]="color === 'black'"
  [class.white]="color === 'white'"
>
  <div #tooltipLabelElement class="label"></div>
  <div #tooltipArrowElement class="arrow"></div>
</div>
